module.exports = __webpack_public_path__ + "static/media/Quicksand_Bold.c3bf00e5.otf";